export default __webpack_public_path__ + "static/media/hero.4205c754.svg";